import { Component, Input } from '@angular/core'

import ModalService from '../../../shared/modal/modal.service'

@Component({
  selector: 'app-credit-card-help-support',
  templateUrl: './credit-card-help-support.component.html',
  styleUrls: ['./credit-card-help-support.component.scss'],
})
export default class CreditCardHelpSupportComponent {
  @Input() rentalPhoneNumber = ''
  @Input() rentalPhoneNumberLink = ''

  constructor(private modalService: ModalService) {}

  closeModal(id: string): void {
    this.modalService.close(id)
  }
}
